export default __webpack_public_path__ + "static/media/AssessmentHub.64d165fe.svg";